module.exports = __webpack_public_path__ + "img/logo.94a37622.png";